import { DeviceUtils } from '@modules/src/utils/DeviceUtils'
import { isTabletViewport } from '@/utils/DeviceLayout'

export const STATIC_BACKGROUND_TINT = 0xa0a8b4

export const shouldDimStaticBackground = (): boolean => {
    if (!DeviceUtils.isMobileDevice()) {
        return false
    }

    const width = window.visualViewport?.width || window.innerWidth
    const height = window.visualViewport?.height || window.innerHeight

    if (width >= height) {
        return true
    }

    return isTabletViewport()
}

export const applyStaticBackgroundTint = (element: { tint?: number } | null | undefined): void => {
    if (!element || typeof element.tint !== 'number') {
        return
    }

    element.tint = shouldDimStaticBackground() ? STATIC_BACKGROUND_TINT : 0xffffff
}
